import axios from 'axios';
import React, { useMemo, useState, useEffect, createContext, useContext } from 'react';
import toast from 'react-hot-toast';
import { userLogin } from '../../api/api';
import { loginInActiveError } from '../../constant-values';

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const userData = JSON.parse(localStorage.getItem('userData'));
    const token = localStorage.getItem('token');
    if (userData && token) {
      setUser(userData);
    }
    setLoading(false);
  }, []);

  const login = async (data) => {
    try {
      const isMobileDevice = () => {
      const ua = navigator.userAgent.toLowerCase();
      const smallScreen = window.innerWidth < 768;
      const isMobileUA = /android|iphone|ipad|mobile|ipod/.test(ua);
      return isMobileUA || smallScreen;
    };
      if (isMobileDevice()) {
      toast.error("Mobile login is restricted.");
      return;
    }
      const response = await userLogin(data);
      const userData = response?.data?.data?.UserDetail;
      localStorage.setItem('userSwitchData', JSON.stringify(response?.data?.data['MappingDetails']));
      localStorage.setItem('userData', JSON.stringify(userData));
      localStorage.setItem('token', response?.data?.data?.Token);
      localStorage.setItem('Privilliages', JSON.stringify(response?.data?.data?.Privilliages));
      toast.success(response?.data?.message || 'Login successful!');
      // window.location.reload();
      setUser(userData);
    } catch (error) {
      console.error("Error:", error);
      toast.error(error?.response?.data?.message === loginInActiveError ? 'User is Inactive Please Contact your Admin'  : error?.response?.data?.message || 'Login failed');
    }
  };

const otpLogin = async (responseData) => {
  try {
    const userData = responseData?.data?.UserDetail;
    const mappingDetails = responseData?.data?.MappingDetails;
    const token = responseData?.data?.Token;
    const privileges = responseData?.data?.Privilliages;
    if (mappingDetails) {
      localStorage.setItem("userSwitchData", JSON.stringify(mappingDetails));
    }
    if (userData) {
      localStorage.setItem("userData", JSON.stringify(userData));
      setUser(userData);
    }
    if (token) {
      localStorage.setItem("token", token);
    }
    if (privileges) {
      localStorage.setItem("Privilliages", JSON.stringify(privileges));
    }
    window.location.reload();
    return true;
  } catch (error) {
    console.error("OTP Login Error:", error);
    toast.error("OTP login failed");
    return false;
  }
};

  const logout = () => {
    localStorage.removeItem('userData');
    localStorage.removeItem('token');
    localStorage.removeItem('Privilliages');
    setUser(null);
    window.location.reload();
    window.location.href = "/login"
  };

  const value = useMemo(() => ({ user, setUser, login, otpLogin, logout }), [user]);

  if (loading) {
    return null;
  }

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
};

export const useRole = () => useContext(AuthContext);
